export const selectIsEditMode = state => state && state.context.isEditMode;
